import '../fonts/LibreBaskerville-Regular.woff2';
import '../fonts/LibreBaskerville-Bold.woff2';
import '../fonts/OpenSans-Regular.woff2';
import '../fonts/OpenSans-SemiBold.woff2';
import '../fonts/OpenSans-Bold.woff2';

import '../img/castle-icon-white.svg';
import '../img/castle-icon-blue.svg';
import '../img/castle-icon-yellow.svg';

import '../sass/main.scss';

import './common/custom-select.js';
import './common/focus.js';
import './common/screen-width.js';
import './common/screen-height.js';
import './common/css-variables.js';

import './layouts/cookies-notice.js';
import './layouts/site-header.js';
import './layouts/site-menu-modal.js';
import './layouts/site-menu-bar.js';

import './common/on-screen.js';

import { initModals } from './common/modals.js';

(() => {
    initModals();
})();
